import useSearchFilters from "@/hooks/useSearchFilters";
import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Button,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { IoCheckmarkSharp, IoRocketOutline } from "react-icons/io5";

const QuickFilters = () => {
  const { t } = useTranslation();
  const {
    selectedFilters,
    handleSelectSota,
    handleSelectEstablished,
    handleSelectNone,
  } = useSearchFilters();

  const toast = useToast();

  const confirmFilters = () => {
    toast({
      position: "top",
      title: t("quickFilters.confirm"),
      status: "success",
      isClosable: true,
      duration: 1000,
    });
  };

  const handleSotaClick = () => {
    handleSelectSota();
    confirmFilters();
  };

  const handleEstablishedClick = () => {
    handleSelectEstablished();
    confirmFilters();
  };

  const handleNoneClick = () => {
    handleSelectNone();
    confirmFilters();
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        color={"inherit"}
        variant={"ghost"}
        _hover={{
          backgroundColor: "transparent",
        }}
        _active={{
          backgroundColor: "transparent",
        }}
        rightIcon={<ChevronDownIcon />}
        leftIcon={<IoRocketOutline />}
      >
        {t("quickFilters.button")}
      </MenuButton>
      <MenuList color={"MenuText"}>
        <MenuItem
          onClick={handleSotaClick}
          backgroundColor={
            selectedFilters === "sota" ? "brand.100" : "Background"
          }
          _hover={{
            backgroundColor: "brand.100",
          }}
        >
          <VStack alignItems={"flex-start"}>
            <HStack alignItems={"center"}>
              <Text fontWeight={"bold"}>{t("quickFilters.sota.title")}</Text>

              {selectedFilters === "sota" && (
                <Icon as={IoCheckmarkSharp} w={5} h={5} />
              )}
            </HStack>
            <Text>{t("quickFilters.sota.description")}</Text>
          </VStack>
        </MenuItem>
        <MenuItem
          onClick={handleEstablishedClick}
          backgroundColor={
            selectedFilters === "established" ? "brand.100" : "Background"
          }
          _hover={{
            backgroundColor: "brand.100",
          }}
        >
          <VStack alignItems={"flex-start"}>
            <HStack alignItems={"center"}>
              <Text fontWeight={"bold"}>
                {t("quickFilters.established.title")}
              </Text>
              {selectedFilters === "established" && (
                <Icon as={IoCheckmarkSharp} w={5} h={5} />
              )}
            </HStack>

            <Text>{t("quickFilters.established.description")}</Text>
          </VStack>
        </MenuItem>
        <MenuItem
          onClick={handleNoneClick}
          _hover={{
            backgroundColor: "brand.100",
          }}
        >
          <Text fontWeight={"bold"}>{t("quickFilters.none")}</Text>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default QuickFilters;
